export class CustomerIdentifier {
  product_id: string;
  customer_id: string;
  customer_part_identifier: string;
  id?: string;
}
